import {
  snapRound,
  type SnapRoundingOptions,
  SnapRoundingOptionsDecimal,
  SnapRoundingOptionsDecimalPercent,
  snapRoundPerUnit,
} from '@calculations/round/decimal';
import { dec, Decimal } from '@snap-types/types/decimal';

export type ContributionMarginCalculation = {
  unitPrice: Decimal;
  unitVariableCosts: Decimal;
  contributionMargin: Decimal;
};

export function calculateUnitPriceFromContributionMargin(
  {
    contributionMargin,
    unitVariableCosts,
  }: {
    unitVariableCosts: Decimal;
    contributionMargin: Decimal;
  },
  roundingOptions: SnapRoundingOptions = SnapRoundingOptionsDecimal,
): ContributionMarginCalculation {
  if (contributionMargin.gte(dec('1'))) {
    throw new Error('Contribution Margin cannot be greater than or equal to 1');
  }

  const unitPrice = snapRoundPerUnit(
    unitVariableCosts.dividedBy(dec('1').minus(contributionMargin)),
    roundingOptions,
  );

  return {
    unitPrice,
    unitVariableCosts,
    contributionMargin,
  };
}

export function calculateContributionMarginFromUnitPrice(
  {
    unitPrice,
    unitVariableCosts,
  }: {
    unitVariableCosts: Decimal;
    unitPrice: Decimal;
  },
  roundingOptions: SnapRoundingOptions = SnapRoundingOptionsDecimalPercent,
): Decimal {
  if (unitPrice.eq(dec('0'))) {
    throw new Error('Unit Price cannot be 0');
  }

  const contributionMargin = snapRound(
    unitPrice.minus(unitVariableCosts).dividedBy(unitPrice),
    roundingOptions,
  );

  return contributionMargin;
}
